import React, { useState } from 'react';
import { LatestSplit } from 'types/splits.types';
import { format } from 'date-fns';
import { dateFormats } from 'app/constants';
import { Button, Flex, Skeleton, Text } from '@chakra-ui/react';

export interface LatestSplitListHeadingProps {
  isLoading: boolean;
  split?: LatestSplit;
  downloadSplitPdf: () => Promise<void>;
}
export const LatestSplitListHeading: React.FC<LatestSplitListHeadingProps> = ({
  isLoading,
  split,
  downloadSplitPdf,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  return (
    <Flex justify="space-between" whiteSpace="nowrap" mb={8} width="full">
      {isLoading ? (
        <Skeleton width={350} height={6} />
      ) : (
        <>
          <Flex whiteSpace="nowrap" overflow="hidden" maxWidth="600px">
            <Text
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              as="span"
              fontSize="md"
              fontWeight={500}
              data-testid="latest-split-creator-name"
              title={split?.createdBy.profileCard.displayName}
            >
              By {split?.createdBy.profileCard.displayName}&nbsp;
            </Text>
            <Text
              as="span"
              data-testid="latest-split-creation-date"
              fontSize="md"
              fontWeight={500}
            >
              (
              {split?.created &&
                format(new Date(split.created.iso), dateFormats.LIST_FORMAT)}
              )
            </Text>
          </Flex>
          {split?._links?.getLatestWorkSplitPdf && (
            <Button
              isDisabled={isDownloading}
              onClick={async () => {
                setIsDownloading(true);
                await downloadSplitPdf();
                setIsDownloading(false);
              }}
              variant="secondary"
              size="md"
            >
              Download
            </Button>
          )}
        </>
      )}
    </Flex>
  );
};
